import React from "react";
import Navbar from "../components/sections/Navbar";
import Hero from "../components/sections/Hero";
import Marquee from "../components/sections/Marquee";
import About from "../components/sections/About";
import Services from "../components/sections/Services";
import WhyUs from "../components/sections/WhyUs";
import Stats from "../components/sections/Stats";
import Industries from "../components/sections/Industries";
import Contact from "../components/sections/Contact";
import Footer from "../components/sections/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-white text-slate-900 font-body antialiased">
      <Navbar />
      <Hero />
      <Marquee />
      <About />
      <Services />
      <WhyUs />
      <Stats />
      <Industries />
      <Contact />
      <Footer />
    </main>
  );
}
